import moduleMain from '@_system/store/module/main.js'
import systemStore from '@_system/store/store.js'
const store = {
	state: {
		app: null,
		logincompany: 'oa_logincompany',
		token: window.config.app +'_token',
		// mainContainer: null,
		baseURL: 'http://47.98.231.105/api/public/index.php',
		importTemplate: 'http://47.98.231.105/api/public/importTemplate',
		scanmoduleMap: {
			purchasevoucher: 'views/scan/purchasevoucher/uploadvoucher/index.vue',
		},
		moduleMap: {
			// offer: 'views/main/underline/offer/index.vue',
			// invoiceoutput: 'views/main/finance/invoiceoutput/index',
			// supplier: 'views/main/supplier/index',
			// warehouse: 'views/main/warehouse/index',
			// goods: 'views/main/goodsmanage/goods/index',
		},
		formMap: {
			supplier: 'components/forms/supplier/form.vue',
			supplierupload: 'components/forms/supplier/supplierupload/form.vue',
			supplierinvoice: 'components/forms/supplierinvoice/form.vue',
			goods: 'components/forms/goods/form.vue',
			goodsworkflow: 'components/forms/goodsworkflow/form.vue',
			goodsonline: 'components/forms/goodsonline/form.vue',
			goodsgroup: 'components/forms/goodsgroup/form.vue',
			goodsprofit: 'components/forms/goodsprofit/form.vue',
			warehouse: 'components/forms/warehouse/form.vue',
			policy: 'components/forms/policy/form.vue',
			purchase: 'components/forms/purchase/form.vue',
			wlnpurchase: 'components/forms/wlnpurchase/form.vue',
			wlnfinbill: 'components/forms/wlnfinbill/form.vue',
			invoicetype: 'components/forms/finance/invoicetype/form.vue',
			invoiceinput: 'components/forms/finance/invoiceinput/form.vue',
			invoiceoutput: 'components/forms/finance/invoiceoutput/form.vue',
			invoicematch: 'components/forms/finance/invoicematch/form.vue',
			customer: 'components/forms/customer/form.vue',
			crmcustomer: 'components/forms/crmcustomer/form.vue',
			crmcustomerarchive: 'components/forms/crmcustomerarchive/form.vue',
			crmcustomerflowup: 'components/forms/crmcustomerflowup/form.vue',
			saleorder: 'components/forms/saleorder/form.vue',
			parcel: 'components/forms/parcel/form.vue',
			offer: 'components/forms/offer/form.vue',
			wlnorder: 'components/forms/wlnorder/form.vue',
			bidcoefficient: 'components/forms/bidcoefficient/form.vue',
			company: 'components/forms/company/form.vue',
			invoiceorder: 'components/forms/invoiceorder/form.vue',
			collection: 'components/forms/collection/form.vue',
			invoiceoutputapply: 'components/forms/invoiceoutputapply/form.vue',
			invoicecustomer: 'components/forms/finance/invoicecustomer/form.vue',
			invoicecustomerorder: 'components/forms/finance/invoicecustomerorder/form.vue',
			collectioncustomer: 'components/forms/finance/collectioncustomer/form.vue',
			recommend: 'components/forms/recommend/form.vue',
			contract: 'components/forms/contract/form.vue',
			customerservicekpi: 'components/forms/customerservicekpi/form.vue',
			stafflifecycle: 'components/forms/stafflifecycle/form.vue',
			reconciliation: 'components/forms/reconciliation/form.vue',
			reconciliationcurrent: 'components/forms/reconciliationcurrent/form.vue',
			reconciliationcurrentworkorder: 'components/forms/reconciliationcurrent/reconciliationcurrentworkorder/form.vue',
			reconciliationbill: 'components/forms/reconciliationbill/form.vue',
			purchasefinbill: 'components/forms/purchasefinbill/form.vue',
			operatetask: 'components/forms/operate/operatetask/form.vue',
			salemanscore: 'components/forms/salemanscore/form.vue',
			reconciliation_pay: 'components/forms/reconciliation_pay/form.vue',
			paymentapplication: 'components/forms/paymentapplication/form.vue',
			material: 'components/forms/material/form.vue',
			wlnpurchaseworkorder: 'components/forms/wlnpurchaseworkorder/form.vue',
			transferaccounts: 'components/forms/transferaccounts/form.vue',
			relatedcompany: 'components/forms/relatedcompany/form.vue',
			newgoodsrecord: 'components/forms/newgoodsrecord/form.vue',
			clickfarm: 'components/forms/clickfarm/form.vue',
			financescore: 'components/forms/financescore/form.vue',
			budget: 'components/forms/budget/form.vue',
			costorder: 'components/forms/costorder/form.vue',
			formalcostorder: 'components/forms/formalcostorder/form.vue',
			formaltransferaccount: 'components/forms/formaltransferaccount/form.vue',
			paymentapplicationtsk: 'components/forms/paymentapplicationtsk/form.vue',
			collectionsupplier: 'components/forms/collectionsupplier/form.vue',
			qualitytest: 'components/forms/qualitytest/form.vue',
			qualitytestpurchaseback: 'components/forms/qualitytestpurchaseback/form.vue',
			customizedproductconsult: 'components/forms/customizedproductconsult/form.vue',
			customizedproductorder: 'components/forms/customizedproductorder/form.vue',
			expresscompany: 'components/forms/expresscompany/form.vue',
			expressreconciliation: 'components/forms/expressreconciliation/form.vue',
			tradelossrecord: 'components/forms/tradelossrecord/form.vue',
			newgoodsapproval: 'components/forms/newgoodsapproval/form.vue',
			exchangeorder: 'components/forms/exchangeorder/form.vue',
			expressstop: 'components/forms/expressstop/form.vue',
			universalinvoice: 'components/forms/universalinvoice/form.vue',
		},
		customformMap: {
			receipt: 'views/main/paymentapplication/lib/receipt/index.vue',
		},
		custompageMap: {
			supplierboxrule: 'views/main/supplier/boxrule/index.vue',
			lucksheet: 'tool/lucksheet/index.vue',
		},
		reportMap: {
			collection: 'components/reports/finance/collection/report.vue',
			invoiceoutput: 'components/reports/finance/invoiceoutput/report.vue',
			offer: 'components/reports/offer/report.vue',
			crmcustomer: 'components/reports/crmcustomer/report.vue',
			recommend: 'components/reports/recommend/report.vue',
			invoicecustomerorder: 'components/reports/finance/invoicecustomerorder/report.vue',
			reconciliation: 'components/reports/reconciliation/report.vue',
			packererror: 'components/reports/packererror/report.vue',
			deliveryerror: 'components/reports/deliveryerror/report.vue',
			reconciliation_bankflow: 'components/reports/reconciliationbankflow/report.vue',
			unpackingtime: 'components/reports/unpackingtime/report.vue',
			invoice: 'components/reports/invoice/report.vue',
			warehousepurchase: 'components/reports/warehousepurchase/report.vue',
			supplieraccounts: 'components/reports/supplieraccounts/report.vue',
			compensationtrade: 'components/reports/compensationtrade/report.vue',
			suppliercompany: 'components/reports/suppliercompany/report.vue',
		},



		toolbarButtons: [{
			code: 'syninvoice',
			name: '同步发票信息',
			status: '',
		},{
			code: 'directlystockin',
			name: '直接入库单',
			status: '',
		}, {
			code: 'autodistribution',
			name: '自动分配',
			// type:'text',
			status: 'warning',
		}, {
			code: 'batchdistribution',
			name: '批量分配',
			// type:'text',
			status: 'warning',
		}, {
			code: 'autoinvoice',
			name: '批量开票',
			// type:'text',
			status: 'warning',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'autopullorders',
			name: '批量同步',
			// type:'text',
			status: 'warning',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'autoremark',
			name: '批量备注',
			// type:'text',
			status: 'warning',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'config',
			name: '配置',
			// type:'text',
			status: 'danger',
		}, {
			code: 'importsearch',
			name: '导入查询',
			// type:'text',
			status: 'success',
			group: {
				name: '导入',
				status: 'success'
			}
		}, {
			code: 'importsearchtemplate',
			name: '导入查询模板',
			// type:'text',
			status: 'success',
			group: {
				name: '导入',
				status: 'success'
			}
		}, {
			code: 'push',
			name: '推送',
			// type:'text',
			// icon: 'vxe-icon-edit',
			group: {
				name: '同步万里牛',
				status: 'warning'
			},
			status: 'warning',
		}, {
			code: 'pull',
			name: '拉取',
			// type:'text',
			// icon: 'vxe-icon-edit',
			group: {
				name: '同步万里牛',
				status: 'warning'
			},
			status: 'primary',
		}, {
			code: 'grabinvoice',
			name: '白名单订单',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'warning',
		}, {
			code: 'toinvoiceoutput',
			name: '转销项',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'warning',
		}, {
			code: 'join',
			name: '合并',
			status: 'success'
		}, {
			code: 'clearerror',
			name: '清空错误单据',
			status: 'danger'
		}, {
			code: 'uploadinvoice',
			name: '上传发票',
			status: 'success'
		}, {
			code: 'reinvoice',
			name: '批量重开',
			status: 'success'
		}, {
			code: 'synchronous',
			name: '同步',
			status: 'primary'
		}, {
			code: 'settlementbatch',
			name: '批量结算',
			status: 'danger'
		}, {
			code: 'message',
			name: '消息',
			status: 'danger'
		}, {
			code: 'paymentsummary',
			name: '付款汇款汇总',
			status: 'success'
		}, {
			code: 'fundapplication',
			name: '资金申请',
			status: 'danger'
		}, {
			code: 'statistics',
			name: '统计',
			status: 'success'
		}, {
			code: 'detail',
			name: '详情',
			status: 'warning'
		}, {
			code: 'scheduling',
			name: '排期',
			status: 'success'
		}, {
			code: 'reportgoods',
			name: '报货',
			status: 'danger',
			custom: true,
		}, {
			code: 'bargain',
			name: '砍价',
			status: 'primary',
			custom: true,
		},
		{
			code: 'takegoods',
			name: '提货',
			status: 'success',
			custom: true,
		}, {
			code: 'reportbatchgoods',
			name: '批量报货',
			status: 'success',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'takebatchgoods',
			name: '批量提货',
			status: 'success',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'updatetakedepartment',
			name: '变更提货部门',
			status: 'danger',
		}, {
			code: 'handle',
			name: '处理',
			status: 'success',
		}, {
			code: 'invoicewriteoff',
			name: '发票核销',
			status: 'danger',
		}, {
			code: 'sendemailbatch',
			name: '核对账单',
			status: 'success',
			group: {
				name: '批量发送',
				status: ''
			}
		}, {
			code: 'sendinvoicebatch',
			name: '索要发票',
			status: 'success',
			group: {
				name: '批量发送',
				status: ''
			}
		}, {
			code: 'reconciliation',
			name: '对账',
			status: 'warning'
		}, {
			code: 'reconciliationbatch',
			name: '批量对账',
			status: 'warning'
		}, {
			code: 'sendjindie',
			name: '同步金蝶',
			// type:'text',
			// status: 'primary',
			status: 'success',
		}, {
			code: 'sendwln',
			name: '同步万里牛',
			// type:'text',
			// status: 'primary',
			status: 'success',
		}, {
			code: 'competitive',
			name: '竞品穿透',
			// type:'text',
			// status: 'primary',
			status: 'danger',
		}, {
			code: 'boxconfig',
			name: '盒箱规配置',
			// type:'text',
			// status: 'primary',
			status: 'success',
		}, {
			code: 'synchronousjindie',
			name: '同步金蝶',
			// type:'text',
			// status: 'primary',
			status: 'danger',
		}, {
			code: 'operationtask',
			name: '运营任务',
			// type:'text',
			// status: 'primary',
			status: 'warning',
		}, {
			code: 'modifieddetail',
			name: '调整明细',
			custom: true,
			// type:'text',
			// status: 'primary',
			status: 'warning',
		}, {
			code: 'bonus',
			name: '加分',
			// type:'text',
			// status: 'primary',
			status: 'primary',
		}, {
			code: 'deduct',
			name: '减分',
			// type:'text',
			// status: 'primary',
			status: 'danger',
		}, {
			code: 'scoredetail',
			name: '积分变更明细',
			// type:'text',
			// status: 'primary',
			status: 'primary',
		}, {
			code: 'jindieconfig',
			name: '星空配置',
			// type:'text',
			// status: 'primary',
			status: 'success',
		}, {
			code: 'applyimprest',
			name: '备用金申请',
			status: 'danger',
		}, {
			code: 'tocostorder',
			name: '转费用',
			status: '',
		}, {
			code: 'payaccconfig',
			name: '付款账号配置',
			status: '',
		}, {
			code: 'yqdzinvoicebatch',
			name: '导出亿企赢开票模板',
			status: '',
		}, {
			code: 'dailyreconciliation',
			name: '日对账',
			status: '',
		}, {
			code: 'ordertrackcode',
			name: '跟单二维码',
			status: '',
		}, {
			code: 'enter',
			name: '录入',
			status: '',
		}, {
			code: 'transferbill',
			name: '调拨',
			status: '',
		}, {
			code: 'distributionprice',
			name: '分销价',
			status: 'success',
		}],



		operateButtons: [{
				code: 'materialreport',
				content: '材报',
				status: 'danger',
				icon: 'vxe-icon-save',
				inrow: true,
			}, {
				code: 'save',
				content: '保存',
				status: 'success',
				icon: 'vxe-icon-save',
				inrow: true,
			}, {
				code: 'distribution',
				content: '分配',
				status: 'success',
				icon: 'vxe-icon-swap',
				inrow: true,
			}, {
				code: 'suggest',
				content: '建议',
				status: 'success',
				icon: 'vxe-icon-swap',
				inrow: true,
			}, {
				code: 'audit',
				content: '审核',
				status: 'warning',
				icon: 'vxe-icon-square-checked',
				inrow: true,
			}, {
				code: 'detail',
				content: '详情',
				status: 'success',
				icon: 'vxe-icon-num-list',
				inrow: true,
			}, {
				code: 'invoice',
				content: '开票',
				status: 'success',
				icon: 'vxe-icon-envelope',
				inrow: true,
			}, {
				code: 'uninvoice',
				content: '撤销开票',
				status: 'success',
				icon: 'vxe-icon-square-minus'
			}, {
				code: 'split',
				content: '拆分',
				status: 'warning',
				icon: 'vxe-icon-copy',
			}, {
				code: 'join',
				content: '合并',
				status: 'warning',
				icon: 'vxe-icon-link',
			}, {
				code: 'drop',
				content: '作废',
				status: 'warning',
				inrow: false,
				icon: '',
			}, {
				code: 'reversal',
				content: '冲红',
				status: 'warning',
				icon: 'vxe-icon-undo',
			}, {
				code: 'reissue',
				content: '重开',
				status: 'warning',
				icon: 'vxe-icon-repeat',
			}, {
				code: 'push',
				content: '推送',
				status: 'warning',
				icon: 'vxe-icon-send',
			}, {
				code: 'pull',
				content: '拉取',
				status: 'warning',
				icon: 'vxe-icon-download',
				inrow: true,
			}, {
				code: 'status',
				content: '状态',
				status: 'warning',
				icon: 'vxe-icon-setting'
			}, {
				code: 'wlnorder',
				content: '线上单号',
				status: 'warning',
				icon: 'vxe-icon-setting'
			},
			{
				code: 'synchronous',
				content: '同步',
				status: 'primary',
				inrow: true
			},
			{
				code: 'reconciliation',
				content: '对账',
				status: 'warning',
				inrow: true
			},
			{
				code: 'file',
				content: '文件',
				status: '',
				icon: 'vxe-icon-file-pdf',
				inrow: true,
			},
			{
				code: 'sendemail',
				content: '发送',
				status: 'success',
				icon: 'vxe-icon-send',
				inrow: true,
			},
			{
				code: 'payment',
				content: '付款',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true
			},
			{
				code: 'receipt',
				content: '回单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true
			},
			{
				code: 'repair',
				content: '修复',
				status: 'danger',
				icon: 'vxe-icon-setting'
			},
			{
				code: 'flowup',
				content: '回访',
				status: 'warning',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'message',
				content: '消息',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'settlement',
				content: '结算',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'mkcode',
				content: 'MK',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'handle',
				content: '处理',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'adjust',
				content: '调价',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'selfpickup',
				content: '自提',
				status: 'danger',
				icon: 'vxe-icon-setting',
			},
			{
				code: 'homedelivery',
				content: '送货上门',
				status: 'danger',
				icon: 'vxe-icon-setting',
			},
			{
				code: 'takegoods',
				content: '提货',
				status: 'primary',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'urgent',
				content: '加急/撤销',
				status: 'primary',
				icon: 'vxe-icon-setting',
			},
			{
				code: 'signature',
				content: '签章',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'backsignature',
				content: '反签章',
				status: 'danger',
				icon: 'vxe-icon-setting',
			},
			{
				code: 'reject',
				content: '驳回',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'addfinbill',
				content: '生成付款单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'closefinbill',
				content: '关闭付款单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'repairfinbill',
				content: '修复付款单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'checkunderline',
				content: '线下已核对',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'deletegroup',
				content: '移除分组',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'datalog',
				content: '日志',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'score',
				content: '积分变更',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'boxrule',
				content: '盒箱规变更',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},			
			{
				code: 'stop',
				content: '停用',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},				
			{
				code: 'enable',
				content: '启用',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'undeal',
				content: '待下单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'deal',
				content: '已下单',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'backwash',
				content: '回冲',
				status: 'danger',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'bill',
				content: '账单',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'voucher',
				content: '凭证',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'autocheck',
				content: '自动核对',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'invoicepreview',
				content: '发票',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: true,
			},
			{
				code: 'newgoods',
				content: '新品',
				status: 'success',
				icon: 'vxe-icon-setting',
				inrow: false,
			},
			{
				code: 'taxinfo',
				content: '涉税信息',
				status: 'success',
				inrow: false,
			},
			{
				code: 'goods',
				content: '产品',
				status: 'success',
				inrow: true,
			}
		],

		tableToolbarButtons: [{
			code: 'online',
			name: '新增组合/线上商品',
			status: 'warning'
		}, {
			code: 'bestparcel',
			name: '运费最小',
			status: 'success'
		}, {
			code: 'synchronizeprices',
			name: '同步价格',
			status: ''
		}, {
			code: 'importonline',
			name: '导入线上订单商品',
			status: 'success'
		}, {
			code: 'wlnpurchase',
			name: '温州仓实际应急',
			status: 'danger',
		}, {
			code: 'automatch',
			name: '自动匹配',
			status: 'success'
		}, {
			code: 'tmprice',
			name: '天猫价',
			status: 'success'
		}, {
			code: 'importstaff',
			name: '导入组员',
			status: 'success'
		}, {
			code: 'reset',
			name: '重置',
			status: 'danger'
		}, {
			code: 'checkonline',
			name: '查询线上',
			status: 'success'
		}, {
			code: 'batchcheck',
			name: '批量核对',
			status: 'warning'
		}, {
			code: 'importcheck',
			name: '导入核对',
			status: 'danger'
		}, {
			code: 'autocheck',
			name: '自动核对',
			status: 'success'
		}, {
			code: 'static',
			name: '统计',
			status: 'danger'
		}, {
			code: 'addyfkd',
			name: '新增预付款单',
			status: 'danger'
		}, {
			code: 'copygoodslist',
			name: '复制商品清单',
			status: ''
		}, {
			code: 'bestprice',
			name: '单价优化',
			status: ''
		}, {
			code: 'getstock',
			name: '库存信息',
			status: 'danger'
		}, {
			code: 'defaultconfig',
			name: '默认配置',
			status: ''
		}, {
			code: 'batchdelete',
			name: '批量删除',
			status: ''
		}, {
			code: 'suppliergrouppurchase',
			name: '供应商集采',
			status: 'danger'
		}, {
			code: 'getcargotype',
			name: '赋码',
			status: 'danger'
		}],
		
		
		
		tableoOperateButtons: [{
			code: 'synchronous',
			name: '同步',
			status: 'primary',
			inrow: true
		}, {
			code: 'reconciliation',
			name: '对账',
			status: 'warning',
			inrow: true
		}, {
			code: 'preview',
			name: '预览',
			status: 'success',
			inrow: true
		}, {
			code: 'audit',
			name: '审核',
			status: 'warning',
			inrow: true
		}, {
			code: 'invoice',
			name: '发票',
			status: 'primary',
			inrow: true
		}, {
			code: 'config',
			name: '配置',
			status: 'primary',
			inrow: true
		}]
	},
	modules: {
		main: moduleMain,
		system: systemStore,
	},
	mutations: {
		addTabs() {
			window.alert(2)
		},
		getTemplate(state, name) {
			let a = document.createElement('a')
			a.setAttribute("href", state.importTemplate + '/' + name + '.xlsx?v=' + Math.random())
			a.setAttribute("download", "")
			a.click()
		},
		setModuleMap(state, payload) {
			state.moduleMap = payload
		}


	},
	actions: {
		// getEmun(state,payload) {
		// 	return new Promise((resolve) => {
		// 		state.commit('getEmun',payload)
		// 		resolve(state.state.emun[payload.field])
		// 	})
		// },		
	},
	getters: {
		breadcrumb() {
			return 321
			//return state.todos.find(todo => todo.id === id)
		}
	}
}
export default {
	store: store
}